import React from 'react';
import { XIcon, CheckIcon } from 'lucide-react';
import { costComparison } from '../data/content';
export function CostTable() {
  return <section aria-labelledby="costo-titulo" className="w-full bg-cream py-14 sm:py-20" data-id="element-41" data-mp="27kx4qgk6adsk">
      <div className="mx-auto max-w-4xl px-5" data-id="element-42" data-mp="1tt8tsglntvd6">
        <h2 id="costo-titulo" className="text-center font-display text-2xl font-extrabold text-navy text-balance sm:text-3xl" data-id="element-43" data-mp="1yr1yt6b88jbv">
          ⚖️ La comparación que nadie hace — pero todos deberían
        </h2>

        <div className="mt-9 overflow-hidden rounded-2xl border border-navy/10 bg-white shadow-card" data-id="element-44" data-mp="2qh6q7oxem6ml">
          <div className="grid grid-cols-2" data-id="element-45" data-mp="2chdsh9ngmq54">
            <h3 className="flex items-center gap-2 bg-coral px-4 py-3 font-display text-sm font-extrabold uppercase tracking-wide text-white sm:px-6 sm:text-base" data-id="element-46" data-mp="2ckt4u4pr1l2u">
              <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-47" data-mp="111p2e9ewtb03" />
              Sin MegaPack
            </h3>
            <h3 className="flex items-center gap-2 bg-green-700 px-4 py-3 font-display text-sm font-extrabold uppercase tracking-wide text-white sm:px-6 sm:text-base" data-id="element-48" data-mp="163xxbbbcen4u">
              <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-49" data-mp="2jhm0ebf1dji2" />
              Con MegaPack
            </h3>
          </div>

          <ul data-id="element-50" data-mp="2xi6if5d4nbai">
            {costComparison.map((row, index) => <li key={row.without} className={`grid grid-cols-2 border-t border-navy/10 ${index % 2 === 1 ? 'bg-cream' : 'bg-white'}`} data-id="element-51" data-mp="2sh90mtw14j9j" data-mpi={index}>
                <p className="border-r border-navy/10 px-4 py-4 text-sm leading-relaxed text-navy/70 sm:px-6" data-id="element-52" data-mp="32ewyhsoxm6vx">
                  {row.without}
                </p>
                <p className="px-4 py-4 text-sm font-bold leading-relaxed text-navy sm:px-6" data-id="element-53" data-mp="3b89ux4m7fqmr">
                  {row.with}
                </p>
              </li>)}
          </ul>
        </div>

        <p className="mt-9 text-center font-display text-2xl font-extrabold text-navy text-balance sm:text-3xl" data-id="element-54" data-mp="3l6ppjhkfxi10">
          120 horas de tu vida por año — o un sistema listo hoy.
        </p>
        <p className="mt-2 text-center font-display text-lg font-bold text-celeste-dark" data-id="element-55" data-mp="12thjh3l5w07">
          Hacé la cuenta.
        </p>
      </div>
    </section>;
}